// ─── Score color: ≥80 green, 60-79 amber, <60 red ────────────────────────────

function scoreColor(score: number): string {
  if (score >= 80) return 'var(--color-accent)';
  if (score >= 60) return 'var(--color-accent-gold)';
  return 'var(--color-accent-red)';
}

// ─── Props ────────────────────────────────────────────────────────────────────

interface ScoreCellProps {
  value: number | null;
}

// ─── ScoreCell ────────────────────────────────────────────────────────────────

export function ScoreCell({ value }: ScoreCellProps) {
  if (value === null) {
    return <span style={{ color: 'var(--color-text-muted)', fontSize: '13px' }}>—</span>;
  }
  const score = Math.round(value);
  return (
    <span
      style={{
        fontFamily: 'var(--font-heading)',
        fontWeight: 700,
        fontSize: '14px',
        color: scoreColor(score),
      }}
    >
      {score}
    </span>
  );
}

export default ScoreCell;
